"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Snap = require("snapsvg");
const utils_1 = require("./utils");
class MapPinCardSvgComponent {
    constructor(details, snapCtx, position, dimensions) {
        this.details = details;
        this.snapCtx = snapCtx;
        this.position = position;
        this.dimensions = dimensions;
    }
    draw() {
        return new Promise((resolve, reject) => {
            const container = this.getContainerForCard();
            const parsedSvg = this.getForeignObjectForCard();
            this.groupedElement = this.snapCtx.group(container, parsedSvg);
            this.hide();
            resolve();
        });
    }
    getContainerForCard() {
        const container = this.snapCtx.rect(this.position.x, this.position.y, this.dimensions.width, this.dimensions.height, 10);
        const containerColourAttributes = {
            fillColour: 'white',
            strokeColour: 'black',
            strokeSize: 1,
        };
        utils_1.setColourAttributeForSnapElement(container, containerColourAttributes);
        return container;
    }
    getForeignObjectForCard() {
        const objectDimensions = this.getDimensionsForForeignObject();
        const foreignObjectHtml = this.getForeignObjectHtmlForCard(this.details, objectDimensions, this.position);
        return Snap.parse(foreignObjectHtml);
    }
    getDimensionsForForeignObject() {
        const cardWidth = this.dimensions.width * 0.95;
        const cardHeight = this.dimensions.height * 0.95;
        return { width: cardWidth, height: cardHeight };
    }
    getForeignObjectHtmlForCard(details, dimensions, position) {
        return `
    <svg>
      <foreignObject width="${dimensions.width}" height="${dimensions.height}" x="${position.x}" y="${position.y}">
        <p>
          <b>${details.title}</b>
          <br/>
            ${details.description}
        </p>
      </foreignObject>
    </svg>`;
    }
    hide() {
        this.makeElementVisible(false);
    }
    show() {
        this.makeElementVisible(true);
    }
    makeElementVisible(visible) {
        const attributeValue = visible ? 'visible' : 'hidden';
        this.groupedElement.attr({
            visibility: attributeValue,
        });
    }
}
exports.MapPinCardSvgComponent = MapPinCardSvgComponent;
